<template>
    <div :style="`padding: ${verticalPadding}rem 0rem`">
        <div 
            class="diamond border-radius display-flex align-items-center justify-content-center" 
            :style="`width: ${size}rem; height: ${size}rem;`" 
            :class="bgColor"
        >
            <div class="content sb white-base" :class="fontSize"> {{ content }}  </div>
        </div>
    </div>
</template>

<script>

export default {
	name: 'b-diamond',
	components: {
	},
    computed: {
        bgColor() {
            return `bg-${this.color}-base`;
        }
    },
	props: {
        color: {
            type: String,
            default: 'blue'
        },
        content: {
            type: String
        },
        size: {
            type: String, 
            default: '4.8'
        },
        fontSize: {
            type: String,
            default: 'font-size-xxbig'
        },
        verticalPadding: {
            type: Number,
            default: 1.2
        }
	}
};
</script>

<style scoped lang="scss">
.diamond {
    transform: rotate(45deg);
    box-shadow: 4px 4px 5px 0 rgba(0,0,0, 0.14),
}
.content{
    transform: rotate(-45deg);
}
</style>

<docs>
    BDiamong
    ```js 
    <b-diamond color="purple" content="3"/>
    ```
</docs>
